import * as userActions from '../user/actions';
import * as lawsDoctypesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsDoctypesReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsDoctypesActions.SET_LAWS_DOCTYPES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsDoctypesActions.SET_LAWS_DOCTYPES_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsDoctypesActions.SET_LAWS_DOCTYPES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsDoctypesActions.ABORT_DOCTYPES_REQUEST:
            return initialState;

        case lawsDoctypesActions.CLEAN_LAWS_DOCTYPES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 17+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 21+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsDoctypes/reducer.js